/**
 * Normalize operator email for API identity and MongoDB lookups.
 * Fixes URL-encoded @ (%40) or double-encoded values from cookies/query strings.
 */
export function normalizeOperatorEmail(raw: string | null | undefined): string {
  if (raw == null || raw === "") return "";
  let s = String(raw).trim();
  try {
    let prev = "";
    for (let i = 0; i < 5 && s !== prev; i += 1) {
      prev = s;
      s = decodeURIComponent(s);
    }
  } catch {
    // ignore malformed sequences
  }
  s = s.replace(/%40/gi, "@");
  return s.trim().toLowerCase();
}

/**
 * Canonical admin-chat threadKey: normalize the operator-email segment only
 * (suffix is game ObjectId or '_' and must stay case-preserved).
 */
/**
 * Build admin-chat threadKey the same way the API does (`operatorEmail::gameId` or `::_`).
 */
export function buildAdminChatThreadKeyForPortal(
  operatorEmail: string,
  gameId: string | null | undefined,
): string {
  const op = normalizeOperatorEmail(operatorEmail);
  const raw = gameId != null ? String(gameId).trim() : "";
  const suffix = raw && /^[a-fA-F0-9]{24}$/i.test(raw) ? raw.toLowerCase() : "_";
  return `${op}::${suffix}`;
}

export function normalizeAdminChatThreadKey(threadKey: string | null | undefined): string {
  const raw = String(threadKey ?? "").trim();
  if (!raw) {
    return "";
  }
  const idx = raw.indexOf("::");
  if (idx < 0) {
    return normalizeOperatorEmail(raw);
  }
  const op = normalizeOperatorEmail(raw.slice(0, idx));
  const rest = raw.slice(idx + 2).trim();
  const suffix = rest && rest !== "_" && /^[a-fA-F0-9]{24}$/i.test(rest)
    ? rest.toLowerCase()
    : rest;
  return `${op}::${suffix}`;
}
